export const Durations = {
    short: 0.4,
    zoom: 1,
    push: 0.6,
};
// Easings
export const Easings = {
    quartIn: [0.5, 0, 0.75, 0],
    quartOut: [0.25, 1, 0.5, 1],
    quartInOut: [0.76, 0, 0.24, 1],
};
// Shorthands
export const shortTransition = {
    transition: {
        duration: Durations.short,
        ease: Easings.quartInOut,
    },
};
export const pushTransition = {
    transition: {
        duration: Durations.push,
        ease: Easings.quartInOut,
    },
};
export const zoomTransition = {
    transition: {
        duration: Durations.zoom,
        ease: Easings.quartInOut,
    },
};
export const originXYZero = {
    originX: 0,
    originY: 0,
};
export const instantTransition = {
    transition: {
        duration: 0,
    },
};
